module.exports = __webpack_public_path__ + "static/img/newQRCode.37e33c7b.jpg";